import React from "react";
import {BaseCheckbox} from "../../baseComponents";

const TatvamCheckbox = (props) => {
    return (
        <BaseCheckbox {...props} />
    )
}

export default TatvamCheckbox;
